import React from 'react'
import PropTypes from 'prop-types'

import LoadingSpinner from 'components/LoadingSpinner'

import styles from './index.css'

export default class Button extends React.Component {
  
  static propTypes = {
    fullWidth: PropTypes.bool,
    onClick : PropTypes.func,
    color : PropTypes.oneOf(['orange', 'grey', 'greyblue', 'darkgreywhite']),
    loading: PropTypes.bool,
    style : PropTypes.object,
    type : PropTypes.string,
  }

  static defaultProps = {
    fullWidth : true,
    color: 'orange',
    loading: false,
    style : {},
    type: 'button'
  }

  constructor(props) {
    super(props)
  }

  render() {
    let classes = [styles.Button]
    if (this.props.fullWidth) {
      classes.push(styles.fullWidth)
    }
    classes.push(styles[this.props.color])

    const loadingIcon = <LoadingSpinner size={16} />
    return (
      <button 
        type={this.props.type}
        className={classes.join(' ')}
        onClick={this.props.onClick}
        style={this.props.style}
        >
        {this.props.loading ? loadingIcon : this.props.children}
      </button>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/buttons/Button/index.jsx